import { useEffect } from 'react';
import PAGES from './pages.json';

const SITE = 'https://medix.cl';

// Título, descripción, canonical y datos estructurados (JSON-LD) de cada página.
// El HTML inicial de cada página lo genera scripts/prerender-meta.js desde el mismo pages.json.
const usePageMeta = (path, jsonLd) => {
  useEffect(() => {
    const page = PAGES[path] || PAGES['/'];
    document.title = page.title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', page.description);
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', SITE + path);

    if (!jsonLd) return undefined;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.dataset.page = 'true';
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);
    return () => script.remove();
  }, [path, jsonLd]);
};

export default usePageMeta;
